module.exports = __webpack_public_path__ + "img/semiglazova.33d9e1d1.jpg";